import { render, staticRenderFns } from "./AdvertiserOwner.vue?vue&type=template&id=e5985398"
import script from "./AdvertiserOwner.vue?vue&type=script&lang=js"
export * from "./AdvertiserOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports